module.exports = __webpack_public_path__ + "img/p3.a8fa1e10.png";